// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* NOC Base */
.noc-dashboard {
    display: flex;
    height: 90vh;
    background-color: #fff;
    color: #f8fafc;
    overflow: hidden;
    transition: all 0.5s ease;
}

.noc-main {
    flex: 1 1;
    display: flex;
    flex-direction: column;
    padding: 20px;
    gap: 15px;
}

/* Centered Selection Mode */
.centered-mode .noc-main {
    justify-content: center;
    align-items: center;
}

.centered-mode .noc-selection-box {
    display: block;
    color: #94a3b8;
    margin-bottom: 12px;
    font-size: 14px;
}

.selection-hint {
    margin-top: 20px;
    color: #64748b;
    font-size: 14px;
}

/* Control Bar (Used in both modes) */
.noc-controls {
    display: flex;
    gap: 15px;
    justify-content: center;
    align-items: center;
}

.noc-group { display: flex; gap: 10px; }

.noc-input {
    background: #1e293b;
    border: 1px solid #334155;
    color: #f8fafc;
    padding: 10px 15px;
    border-radius: 8px;
    font-size: 14px;
    outline: none;
    min-width: 200px;
}

.noc-btn {
    padding: 10px 25px;
    border-radius: 8px;
    border: none;
    font-weight: 700;
    cursor: pointer;
    transition: 0.3s;
}

.noc-btn.start { background: #10b981; color: white; }
.noc-btn.start:disabled { background: #334155; cursor: not-allowed; opacity: 0.6; }
.noc-btn.stop { background: #ef4444; color: white; }

/* Stats & Chart (Only visible when monitoring) */
.noc-stats {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    gap: 15px;
}

.stat-card {
    background: #0f172a;
    padding: 20px;
    border-radius: 12px;
    border: 1px solid #1e293b;
}

.stat-label { font-size: 1.2rem; text-align: center; display: block; color: #fff; font-weight: 700; }
.stat-value { font-size: 1.8rem; text-align: center; font-weight: 800; display: block; margin-top: 5px; }

.rx .stat-value { color: #10b981; }
.tx .stat-value { color: #3b82f6; }

.noc-chart-container {
    flex: 1 1;
    background: #0f172a;
    padding: 25px;
    border-radius: 15px;
    border: 1px solid #1e293b;
    min-height: 0;
}

/* 📱 মোবাইল রেসপন্সিভ স্টাইল (Mobile & Tablet) */
@media (max-width: 768px) {
    .noc-dashboard {
        padding: 10px;
    }

    .noc-controls {
        flex-direction: column; /* ইনপুট এবং বাটন নিচে নিচে আসবে */
        align-items: stretch;
    }

    .noc-group {
        flex-direction: column;
        width: 100%;
    }

    .noc-btn {
        width: 100%; /* বাটন ফুল উইডথ হবে */
    }

    .noc-stats {
        grid-template-columns: 1fr; /* কার্ডগুলো নিচে নিচে আসবে */
        gap: 10px;
    }

    .stat-card {
        padding: 15px;
        flex-direction: row; /* মোবাইলে স্ট্যাটগুলো পাশাপাশি সুন্দর লাগে */
        justify-content: space-between;
    }

    .stat-value {
        font-size: 1.2rem;
    }

    .noc-chart-container {
        height: 300px; /* মোবাইলে চার্টের হাইট কিছুটা কমানো হয়েছে */
        padding: 10px;
    }

    .centered-mode .noc-main {
        margin: 50px auto;
    }
}

/* ছোট মোবাইলের জন্য (Extra Small Devices) */
@media (max-width: 480px) {
    .stat-value {
        font-size: 1rem;
    }
    .noc-title {
        font-size: 1.2rem;
    }
}`, "",{"version":3,"sources":["webpack://./src/components/TrafficMonitor/TrafficMonitor.css"],"names":[],"mappings":"AAAA,aAAa;AACb;IACI,aAAa;IACb,YAAY;IACZ,sBAAsB;IACtB,cAAc;IACd,gBAAgB;IAChB,yBAAyB;AAC7B;;AAEA;IACI,SAAO;IACP,aAAa;IACb,sBAAsB;IACtB,aAAa;IACb,SAAS;AACb;;AAEA,4BAA4B;AAC5B;IACI,uBAAuB;IACvB,mBAAmB;AACvB;;AAEA;IACI,cAAc;IACd,cAAc;IACd,mBAAmB;IACnB,eAAe;AACnB;;AAEA;IACI,gBAAgB;IAChB,cAAc;IACd,eAAe;AACnB;;AAEA,qCAAqC;AACrC;IACI,aAAa;IACb,SAAS;IACT,uBAAuB;IACvB,mBAAmB;AACvB;;AAEA,aAAa,aAAa,EAAE,SAAS,EAAE;;AAEvC;IACI,mBAAmB;IACnB,yBAAyB;IACzB,cAAc;IACd,kBAAkB;IAClB,kBAAkB;IAClB,eAAe;IACf,aAAa;IACb,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;IAClB,kBAAkB;IAClB,YAAY;IACZ,gBAAgB;IAChB,eAAe;IACf,gBAAgB;AACpB;;AAEA,iBAAiB,mBAAmB,EAAE,YAAY,EAAE;AACpD,0BAA0B,mBAAmB,EAAE,mBAAmB,EAAE,YAAY,EAAE;AAClF,gBAAgB,mBAAmB,EAAE,YAAY,EAAE;;AAEnD,iDAAiD;AACjD;IACI,aAAa;IACb,qCAAqC;IACrC,SAAS;AACb;;AAEA;IACI,mBAAmB;IACnB,aAAa;IACb,mBAAmB;IACnB,yBAAyB;AAC7B;;AAEA,cAAc,iBAAiB,EAAE,kBAAkB,EAAE,cAAc,EAAE,WAAW,EAAE,gBAAgB,EAAE;AACpG,cAAc,iBAAiB,EAAE,kBAAkB,EAAE,gBAAgB,EAAE,cAAc,EAAE,eAAe,EAAE;;AAExG,kBAAkB,cAAc,EAAE;AAClC,kBAAkB,cAAc,EAAE;;AAElC;IACI,SAAO;IACP,mBAAmB;IACnB,aAAa;IACb,mBAAmB;IACnB,yBAAyB;IACzB,aAAa;AACjB;;AAEA,iDAAiD;AACjD;IACI;QACI,aAAa;IACjB;;IAEA;QACI,sBAAsB,EAAE,kCAAkC;QAC1D,oBAAoB;IACxB;;IAEA;QACI,sBAAsB;QACtB,WAAW;IACf;;IAEA;QACI,WAAW,EAAE,sBAAsB;IACvC;;IAEA;QACI,0BAA0B,EAAE,6BAA6B;QACzD,SAAS;IACb;;IAEA;QACI,aAAa;QACb,mBAAmB,EAAE,6CAA6C;QAClE,8BAA8B;IAClC;;IAEA;QACI,iBAAiB;IACrB;;IAEA;QACI,aAAa,EAAE,4CAA4C;QAC3D,aAAa;IACjB;;IAEA;QACI,iBAAiB;IACrB;AACJ;;AAEA,4CAA4C;AAC5C;IACI;QACI,eAAe;IACnB;IACA;QACI,iBAAiB;IACrB;AACJ","sourcesContent":["/* NOC Base */\n.noc-dashboard {\n    display: flex;\n    height: 90vh;\n    background-color: #fff;\n    color: #f8fafc;\n    overflow: hidden;\n    transition: all 0.5s ease;\n}\n\n.noc-main {\n    flex: 1;\n    display: flex;\n    flex-direction: column;\n    padding: 20px;\n    gap: 15px;\n}\n\n/* Centered Selection Mode */\n.centered-mode .noc-main {\n    justify-content: center;\n    align-items: center;\n}\n\n.centered-mode .noc-selection-box {\n    display: block;\n    color: #94a3b8;\n    margin-bottom: 12px;\n    font-size: 14px;\n}\n\n.selection-hint {\n    margin-top: 20px;\n    color: #64748b;\n    font-size: 14px;\n}\n\n/* Control Bar (Used in both modes) */\n.noc-controls {\n    display: flex;\n    gap: 15px;\n    justify-content: center;\n    align-items: center;\n}\n\n.noc-group { display: flex; gap: 10px; }\n\n.noc-input {\n    background: #1e293b;\n    border: 1px solid #334155;\n    color: #f8fafc;\n    padding: 10px 15px;\n    border-radius: 8px;\n    font-size: 14px;\n    outline: none;\n    min-width: 200px;\n}\n\n.noc-btn {\n    padding: 10px 25px;\n    border-radius: 8px;\n    border: none;\n    font-weight: 700;\n    cursor: pointer;\n    transition: 0.3s;\n}\n\n.noc-btn.start { background: #10b981; color: white; }\n.noc-btn.start:disabled { background: #334155; cursor: not-allowed; opacity: 0.6; }\n.noc-btn.stop { background: #ef4444; color: white; }\n\n/* Stats & Chart (Only visible when monitoring) */\n.noc-stats {\n    display: grid;\n    grid-template-columns: repeat(3, 1fr);\n    gap: 15px;\n}\n\n.stat-card {\n    background: #0f172a;\n    padding: 20px;\n    border-radius: 12px;\n    border: 1px solid #1e293b;\n}\n\n.stat-label { font-size: 1.2rem; text-align: center; display: block; color: #fff; font-weight: 700; }\n.stat-value { font-size: 1.8rem; text-align: center; font-weight: 800; display: block; margin-top: 5px; }\n\n.rx .stat-value { color: #10b981; }\n.tx .stat-value { color: #3b82f6; }\n\n.noc-chart-container {\n    flex: 1;\n    background: #0f172a;\n    padding: 25px;\n    border-radius: 15px;\n    border: 1px solid #1e293b;\n    min-height: 0;\n}\n\n/* 📱 মোবাইল রেসপন্সিভ স্টাইল (Mobile & Tablet) */\n@media (max-width: 768px) {\n    .noc-dashboard {\n        padding: 10px;\n    }\n\n    .noc-controls {\n        flex-direction: column; /* ইনপুট এবং বাটন নিচে নিচে আসবে */\n        align-items: stretch;\n    }\n\n    .noc-group {\n        flex-direction: column;\n        width: 100%;\n    }\n\n    .noc-btn {\n        width: 100%; /* বাটন ফুল উইডথ হবে */\n    }\n\n    .noc-stats {\n        grid-template-columns: 1fr; /* কার্ডগুলো নিচে নিচে আসবে */\n        gap: 10px;\n    }\n\n    .stat-card {\n        padding: 15px;\n        flex-direction: row; /* মোবাইলে স্ট্যাটগুলো পাশাপাশি সুন্দর লাগে */\n        justify-content: space-between;\n    }\n\n    .stat-value {\n        font-size: 1.2rem;\n    }\n\n    .noc-chart-container {\n        height: 300px; /* মোবাইলে চার্টের হাইট কিছুটা কমানো হয়েছে */\n        padding: 10px;\n    }\n\n    .centered-mode .noc-main {\n        margin: 50px auto;\n    }\n}\n\n/* ছোট মোবাইলের জন্য (Extra Small Devices) */\n@media (max-width: 480px) {\n    .stat-value {\n        font-size: 1rem;\n    }\n    .noc-title {\n        font-size: 1.2rem;\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
